/**
 * Arrondi au centime.
 *
 * Tout est entier de centimes en entrée comme en sortie ; seuls les calculs
 * intermédiaires (un pourcentage, une marge) passent par un flottant. On
 * arrondit à la valeur supérieure en valeur absolue, pour que l'avoir d'une
 * facture retrouve exactement le montant de la facture.
 */
/** Arrondit au centime, symétriquement autour de zéro. */
export function arrondirCentimes(valeur) {
    return Math.sign(valeur) * Math.round(Math.abs(valeur));
}
//# sourceMappingURL=arrondi.js.map